import * as React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme: any) => ({
  formControl: {
    margin: theme.spacing.unit,
    width: '100%',
  },
  group: {
    margin: theme.spacing.unit,
  },
});

class RadioButtonField extends React.PureComponent<any, any> {
  public render() {
    const { field, value, onChange, classes } = this.props;
    return (
      <FormControl className={classes.formControl} required={field.required}>
        <FormLabel component="legend">{field.label}</FormLabel>
        <RadioGroup
          aria-label={field.label}
          name={field.field}
          className={classes.group}
          value={value}
          onChange={onChange}
        >
          {field.options.map((option: string) => (
            <FormControlLabel key={option} value={option} control={<Radio />} label={option} />
          ))}
        </RadioGroup>
      </FormControl>
    );
  }
}

export default withStyles(styles)(RadioButtonField);



// WEBPACK FOOTER //
// ./src/modules/subscription/components/SubscriptionConfig/RadioButtonField.tsx